export * from 'react-native';



// WEBPACK FOOTER //
// ./~/react-native-vector-icons/lib/react-native.js